<script setup>
import ClearModal from '@/components/ClearModal.vue';
import { ref } from 'vue';

defineProps({
    src: {
        type: String,
        required: true,
    },
});
const show = ref(false);

const toggle = () => {
    show.value = !show.value;
};
</script>
<script>
export default {
    name: 'ZoomableImage',
};
</script>

<template>
    <button type="button" @click="toggle">
        <slot />
        <ClearModal :show="show" @close="show = false" with-blur>
            <div @click="show = false">
                <div class="flex justify-center">
                    <img :src="src" alt="" class="block" />
                </div>
                <div class="mt-3">
                    <slot name="under-image" />
                </div>
            </div>
        </ClearModal>
    </button>
</template>
